import { render, staticRenderFns } from "./ShareTip.vue?vue&type=template&id=58b428a5&"
import script from "./ShareTip.vue?vue&type=script&lang=js&"
export * from "./ShareTip.vue?vue&type=script&lang=js&"
import style0 from "./ShareTip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports